/**
 * Абзац из статьи правил, в котором ссылкой на статью стоит само понятие: «Конус — это…», «Пока вы Без сознания…».
 * Понятие ищется по началу первого слова названия, следующие слова названия входят в ссылку, пока совпадают;
 * не нашлось — ссылкой первое слово.
 */
export function ruleParagraph(ruleId: string, title: string, text: string) {
	if (text.includes(`{@rule ${ruleId},`)) return text;
	const masked = text.replace(/\{@[^}]*\}/g, (tag) => '\u0000'.repeat(tag.length));
	const titleWords = title.split(/\s+/);
	const normalize = (value: string) => value.toLowerCase().replace(/ё/g, 'е');
	const matches = (value: string, titleWord: string) => {
		const stem = normalize(titleWord);
		return normalize(value).startsWith(stem.slice(0, Math.max(3, stem.length - 2)));
	};
	const word = /[А-Яа-яЁёA-Za-z-]+/g;
	const words = [...masked.matchAll(word)];
	const startIndex = words.findIndex((m) => matches(m[0], titleWords[0]));
	const from = startIndex >= 0 ? startIndex : words.findIndex((m) => !m[0].includes('\u0000'));
	if (from < 0) return text;
	let count = 1;
	while (
		startIndex >= 0 &&
		count < titleWords.length &&
		words[from + count] &&
		matches(words[from + count][0], titleWords[count])
	)
		count++;
	const last = words[Math.min(from + count, words.length) - 1];
	const start = words[from].index ?? 0;
	const end = (last.index ?? 0) + last[0].length;
	return `${text.slice(0, start)}{@rule ${ruleId}, ${text.slice(start, end)}}${text.slice(end)}`;
}
